import React, { useEffect, useState } from 'react';

//*MUI
import PlusIcon from '../Icons/PlusIcon';
import { DataGrid } from '@mui/x-data-grid';

//*files
import cssClasses from './ParkingMasters.module.css';
import Button from '../../Subcomponents/Button';
import EmptyState from '../../Assets/Images/Common/noProjectFound.svg';
import EditIcon from '../../Assets/Images/Common/EditIcon.svg';
import { useSelector } from 'react-redux';
import AddParkingDetailsModal from './AddParkingDetailsModal/AddParkingDetailsModal';
import { dismissLoader, presentLoader } from '../../Services/loader';
import {
  getParkingDetails,
  getParkingDetailsFromServer,
  insertParkingDetails,
  updateParkingDetails,
} from '../../Services/Bank';
import { errorTost, successTost } from '../../Services/Toast';
import { Box, Tooltip } from '@mui/material';

export const dataGridStyles = {
  '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  border: '1px solid #EAECF0 !important',
  fontWeight: '400',
  fontSize: '1.4rem',
  lineHeight: '2rem',
  color: '#667085',
  fontFamily: 'Inter-Medium',
  borderRadius: '8px',
  '& div[data-colindex="1"]': {
    color: '#101828',
    fontWeight: '500',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    '& .MuiDataGrid-row': {
      borderBottom: '1px solid #EAECF0',
      background: '#FFFFFF',
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: '1rem',

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      borderBottom: '1px solid #EAECF0',
      backgroundColor: '#FFFFFF',
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  '& .MuiDataGrid-iconSeparator ': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader:hover': {
    '& .MuiDataGrid-menuIcon': {
      visibility: 'hidden',
    },
  },
  '& .MuiDataGrid-columnHeaders + div': {
    height: 'calc(100vh - 315px) !important',
  },
  '&  .MuiDataGrid-columnHeaders': {
    background: '#F9FAFB',
    /* Gray/200 */
    border: '1px solid #EAECF0',
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: '1rem',
    borderBottom: '6px solid #EAECF0',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-checkboxInput': {
    '& svg': {
      width: '2rem',
      height: '2rem',
      background: '#FFFFFF',
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  '& .MuiDataGrid-footerContainer': {
    '& .MuiTablePagination-displayedRows ': {
      display: 'none',
    },
    '& .MuiDataGrid-selectedRowCount': {
      visibility: 'hidden ',
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: 'none',
    cursor: 'none',
  },
  "& [title='Go to previous page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to next page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: '1rem',
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: '1rem',
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 4rem',

    '&:focus': {
      outline: 'none',
    },
  },
  '&  .MuiDataGrid-row ': {
    maxHeight: '72px !important',
    minHeight: '72px !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 4rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiButtonBase-root': {
    fontSize: '1.6rem',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 2rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 1rem',

    '&:focus': {
      outline: 'none',
    },
  },
};

function ParkingMasters() {
  const loggedInUser = useSelector((state) => state.Auth.user);
  const [allParkingData, setAllParkingData] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(12);
  const [selectedParkingDetails, setSelectedParkingDetails] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [showAddParkingDetailsModal, setShowAddParkingDetailsModal] =
    useState(false);
  const [pageMaintain, setPageMaintain] = useState(0);

  const tagGridColumns = [
    {
      field: 'action',
      headerName: '',
      width: window.innerWidth < 820 ? 50 : 100,
      renderCell: (params) => {
        return (
          <div style={{ cursor: 'pointer' }}>
            <Tooltip
              placement='bottom-start'
              title={<Box fontSize={'1.5rem'}>Edit</Box>}
            >
              <p
                style={{
                  whiteSpace: 'normal',
                  lineBreak: 'anywhere',
                  opacity: '0.7',
                }}
              >
                <img
                  src={EditIcon}
                  alt='edit'
                  onClick={() => {
                    setIsEdit(true);
                    setSelectedParkingDetails(params?.row);
                    setShowAddParkingDetailsModal(true);
                  }}
                />
              </p>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: 'ParkingTypes',
      headerName: 'Parking Types',
      width: window.innerWidth < 820 ? 160 : 250,
      renderCell: (params) => {
        return <div>{params?.row?.parkingType}</div>;
      },
    }
  ];

  useEffect(() => {
    getAllParking(0, false);
  }, []);

  function getAllParking(pageNumber, merge) {
    getParkingDetailsFromServer(
      pageNumber * pageSize,
      pageNumber * pageSize + pageSize - 1
    )
      .then((parkingRes) => {
        const _arr = parkingRes.data.map((el, index) => ({
          ...el,
          id: el.parkingTypeId,
          index: index,
        }));
        if (merge) {
          setAllParkingData((pre) => [...pre, ..._arr]);
        } else {
          setAllParkingData([..._arr]);
        }
      })
      .catch((err) => {
        dismissLoader();
        if (err?.message) {
          errorTost(err?.message);
        } else {
          errorTost('Something went wrong! Try again');
        }
      });
  }

  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const SaveIntoParkingTable = (val, isUpdate) => {
    presentLoader();
    getParkingDetails(capitalizeFirstLetter(val?.parkingType))
      .then((typeRes) => {
        console.log('typeRes', typeRes);
        if (typeRes.data.length > 0 && typeRes?.data[0]?.parkingTypeId !== selectedParkingDetails.parkingTypeId) {
          dismissLoader()
          errorTost('Parking type already exists');
        } else {
          if (isUpdate) {
            const updatePayload = {
              parkingType: capitalizeFirstLetter(val?.parkingType),
              lastUpdatedBy: loggedInUser?.userId,
              last_updated_at: new Date().getTime(),
              // description: val?.description
            };
            updateParkingDetails(
              updatePayload,
              selectedParkingDetails?.parkingTypeId
            )
              .then((res) => {
                dismissLoader();
                successTost('Parking type updated successfully!');
                getAllParking(0, false);
              })
              .catch((err) => {
                dismissLoader();
                errorTost(err.message);
              });
          } else {
            const addPayload = {
              parkingType: capitalizeFirstLetter(val?.parkingType),
              lastUpdatedBy: loggedInUser?.userId,
              addedBy: loggedInUser?.userId,
              // description: val?.description
            };
            insertParkingDetails(addPayload)
              .then((resp) => {
                dismissLoader();
                successTost('Parking type added successfully!');
                getAllParking(0, false);
              })
              .catch((err) => {
                dismissLoader();
                errorTost(err.message);
              });
          }
        }
      })
      .catch((err) => {
        dismissLoader();
        errorTost(err.message);
      });
  };

  function getMoreData(passPageNumber) {
    setPageNumber(passPageNumber);
    getAllParking(passPageNumber, true);
  }
  return (
    <div className={cssClasses.wrapperPage}>
      <div className={cssClasses.wrapperContent}>
        <div className={cssClasses.wrapperSubContent}>
          <div className={cssClasses.addButton}>
            <Button
              style={{
                color: '#FFFFFF',
                backgroundColor: '#155EEF',
                fontSize: '1.6rem',
                lineHeight: '2.4rem',
                width: '20rem',
              }}
              btnIcon={<PlusIcon />}
              iconPosition={'left'}
              btnName={'Add Parking'}
              clicked={() => {
                setIsEdit(false);
                setSelectedParkingDetails(null);
                setShowAddParkingDetailsModal(true);
              }}
            />
          </div>
          <div style={{ margin: '1rem' }}>
            {allParkingData?.length > 0 ? (
              <DataGrid
                rows={allParkingData}
                columns={tagGridColumns}
                pageSize={10}
                rowsPerPageOptions={[10]}
                page={pageMaintain}
                onPageChange={(_page) => {
                  setPageMaintain(_page);
                  if (pageNumber < _page) {
                    getMoreData(_page);
                  }
                }}
                sx={[dataGridStyles]}
              />
            ) : (
              <div style={{ height: '400px' }}>
                <p
                  style={{
                    position: 'relative',
                    top: '50%',
                    textAlign: 'center',
                    fontSize: '3rem',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <img src={EmptyState} alt='No Data' />
                    <span>No Parking Types Available</span>
                  </div>
                </p>
              </div>
            )}
          </div>
        </div>

        {showAddParkingDetailsModal && (
          <AddParkingDetailsModal
            open={showAddParkingDetailsModal}
            handleClose={() => {
              setShowAddParkingDetailsModal(false);
            }}
            isEdit={isEdit}
            selectedParkingDetails={selectedParkingDetails}
            handleSave={(val, isUpdate) => {
              setShowAddParkingDetailsModal(false);
              SaveIntoParkingTable(val, isUpdate);
            }}
          />
        )}
      </div>
    </div>
  );
}

export default ParkingMasters;
